import {
  Component,
  HostListener,
  Inject,
  PLATFORM_ID,
  OnInit
} from '@angular/core';
import { Stockitem } from '../../../../interfaces/stockitem';
import { AdvancedStocksService } from '../../../../services/advancedstocksservice';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-producthotdeals',
  templateUrl: './producthotdeals.component.html',
  styleUrl: './producthotdeals.component.scss'
})
export class ProducthotdealsComponent implements OnInit {
  isFullPage = false;
  contentReady = true;
  allData: Stockitem[] = [];
  noData = false;

  totalItems = 0;
  stockTotal: any;
  page = 1;

  isAr = false;
  isMobile = false;
  itemCount = 9;

  private isBrowser: boolean;

  constructor(
    private deviceService: DeviceDetectorService,
    private _advancedStocks: AdvancedStocksService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {
    const currentUrl = this.router.url;
    // ⛔ السيرفر يقف هنا
    if (!this.isBrowser) {
      return;
    }
    if (currentUrl.includes('topsale')) {
      this.isFullPage = true;
    }
    // Browser only
    this.isMobile = this.deviceService.isMobileDevice();
    this.itemCount = this.isMobile ? 8 : 9;
    this.isAr = localStorage.getItem('language') === 'ar';

    this.getHotDeals();
  }

  // ================= DATA =================
  getHotDeals(): void {
    this.contentReady = true;
    this.page = 1;

    this._advancedStocks
      .getStocksWithPriceDiff(1, this.page, this.itemCount)
      .subscribe({
        next: (res: any) => {
          this.allData = res.data;
          this.stockTotal = res.total;
          this.totalItems = res.last_page;
          this.noData = this.stockTotal === 0;
          this.contentReady = false;
        },
        error: (err) => {
          console.error('Error fetching hot deals:', err);
          this.contentReady = false;
          this.noData = true;
        }
      });
  }

  // ================= INFINITE SCROLL =================
  @HostListener('window:scroll', [])
  onWindowScroll(): void {

    if (!this.isBrowser || this.contentReady) return;

    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const windowHeight = window.innerHeight;
    const pageHeight = document.documentElement.scrollHeight;

    const bottomReached =
      scrollPosition + windowHeight >= pageHeight - 10;

    if (this.page === 1) {
      this.page = 2;
    }

    if (bottomReached && this.page <= this.totalItems) {
      this.loadMore();
    }
  }

  private loadMore(): void {
    this.contentReady = true;

    this._advancedStocks
      .getStocksWithPriceDiff(1, this.page, this.itemCount)
      .subscribe({
        next: (res: any) => {
          this.allData = [...this.allData, ...res.data];
          this.page++;
          this.noData = this.allData.length === 0;
          this.contentReady = false;
        },
        error: (error) => {
          console.error(error);
          this.contentReady = false;
        },
      });
  }
}
